// TODO: Setup for MFE, load boostrap for now.
// import { loadManifest } from '@angular-architects/module-federation';
// import { getEnvExtension } from '@core/core.helper';

// loadManifest(`./assets/mfe-manifests/mf.manifest${getEnvExtension()}`)
//   .catch((err) => console.error(err))
//   .then(() => import('./bootstrap'))
//   .catch((err) => console.error(err));
import('./bootstrap').catch((err) => console.error(err));
